import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Auditoría',
  description: 'Detectas los villanos químicos en tu cocina, baño y habitación.',
  bg: 'bg-blush-soft',
  accent: 'text-blush-deep'
}, {
  number: '02',
  title: 'Sustitución',
  description: 'Haces cambios de bajo costo que limpian tu sangre en solo días.',
  bg: 'bg-sky-soft',
  accent: 'text-sky-deep'
}, {
  number: '03',
  title: 'Reactivación',
  description: 'Tu cuerpo restaura su equilibrio natural para permitir la concepción.',
  bg: 'bg-sage-soft',
  accent: 'text-sage-deep'
}];
export function HowItWorks() {
  return <section className="w-full bg-sky-soft py-20 md:py-28" data-id="element-141">
      <div className="max-w-6xl mx-auto px-6 md:px-8" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-143">
          <span className="inline-block bg-white text-sky-ink text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-144">
            El proceso
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-145">
            Cómo funciona
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-146">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: index * 0.15
        }} className={`${step.bg} rounded-2xl p-8 md:p-10 relative`} data-id="element-147">
              <span className={`font-serif text-6xl md:text-7xl ${step.accent} leading-none block mb-4 opacity-60`} data-id="element-148">
                {step.number}
              </span>
              <h3 className="font-serif text-2xl md:text-3xl text-ink mb-3" data-id="element-149">
                {step.title}
              </h3>
              <p className="text-ink-soft leading-relaxed" data-id="element-150">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}